import React from "react";
import cancelButton from "../../assets/icons/Cancel-16px-Black-100.svg";
import "./TemplateHeader.scss";
import PropTypes from "prop-types";

const TemplateHeaderNew = ({ heading, subHeading, onClose }) => {
  return (
    <div className="template-header">
      {onClose && (
        <img className="cancel-button" alt="Cancel" onClick={onClose} src={cancelButton} />
      )}
      {heading && <h4 className="heading">{heading}</h4>}
      {subHeading && <h3 className="sub-heading">{subHeading}</h3>}
    </div>
  );
};

TemplateHeaderNew.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  onClose: PropTypes.func,
};

export default TemplateHeaderNew;
